













import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { ApexOptions } from 'apexcharts';

import {
  IBusinessReferral,
  IBusinessReferralChart
} from '@/models/marketingCenter/referral';

import Chart from '@/components/Chart/Chart.vue';
import DateUtils from '@/utils/DateUtils';

@Component({ components: { Chart } })
export default class Statistics extends Vue {
  @Prop() campaign!: IBusinessReferral;
  @Prop() chart!: IBusinessReferralChart;

  @Prop({ default: true }) showTitle!: boolean;
  @Prop({ default: '280' }) height!: string;
  @Prop() legendProps?: any;

  chartKey = 1;
  chartOptions: ApexOptions = {};
  chartSeries: ApexAxisChartSeries = [];

  get tPrefix() {
    return 'referralProgram.statistics';
  }

  @Watch('chart')
  initChart() {
    if (
      typeof this.chart.signUps === 'number' &&
      typeof this.chart.purchases === 'number'
    ) {
      this.chartSeries = [
        {
          name: String(this.$t(`${this.tPrefix}.joined`)),
          data: [this.chart.signUps]
        },
        {
          name: String(this.$t(`${this.tPrefix}.purchase`)),
          data: [this.chart.purchases]
        }
      ];
    }
  }

  initChartOptions() {
    const colors = ['#3E24D6', '#24D6A6'];
    this.chartOptions = {
      xaxis: {
        categories: [String(this.$t(`${this.tPrefix}.category`))]
      },
      yaxis: {
        labels: {
          formatter: (value: number) =>
            Number.isInteger(value) ? String(value) : ''
        }
      },
      chart: {
        toolbar: {
          show: false
        }
      },
      title: {
        text: this.showTitle
          ? String(
              this.$t(`${this.tPrefix}.title`, {
                since: DateUtils.formattedDate({
                  date: this.campaign.createdAt as string
                })
              })
            )
          : ''
      },
      plotOptions: {
        bar: {
          horizontal: true,
          barHeight: '60%'
        }
      },
      stroke: {
        colors: ['transparent'],
        width: 12
      },
      tooltip: {
        marker: {
          show: true,
          fillColors: colors
        }
      },
      dataLabels: {
        enabled: false
      },
      fill: {
        colors: colors
      },
      legend: {
        position: 'top',
        horizontalAlign: 'right',
        markers: {
          fillColors: colors
        },
        ...this.legendProps
      }
    };
  }

  created() {
    this.initChartOptions();
  }
}
